export const booleanToDisplay = (val) => (val ? "Yes" : "No");
